import PressureFilters from './PressureFilters';
export default PressureFilters;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureFilters/index.js